var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sn-f-col-c-c sn-no-data"},[_c('div',{staticClass:"iconfont icon-zanwushuju"}),_c('div',{staticClass:"explain"},[(_vm.message)?[_vm._v(_vm._s(_vm.message))]:_vm._e(),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }